import clsx from 'clsx';
import React from 'react';

export const PropertyList = props => <div {...props} />;

const Title = props => (
  <div
    {...props}
    className={clsx('text-base font-semibold flex items-start mb-0.5', props.className)}
  />
);

export const PropertyListItem = props => (
  <div
    {...props}
    className="grid grid-cols-12 py-2 border-b border-gray-100 dark:border-border gap-x-4"
  />
);

export const PropertyListItemLabel = ({ size = 'default', ...props }) => (
  <div
    {...props}
    className={clsx('font-semibold break-words', {
      'col-span-5': size === 'default',
      'col-span-3': size === 'narrow',
      'col-span-4': size === 'medium',
    })}
  />
);

export const PropertyListItemValue = ({ size = 'default', className, ...props }) => (
  <div
    {...props}
    className={clsx(
      {
        'col-span-7': size === 'default',
        'col-span-9': size === 'narrow',
        'col-span-8': size === 'medium',
      },
      className,
    )}
  />
);

PropertyList.Title = Title;
PropertyList.Item = PropertyListItem;
PropertyList.ItemLabel = PropertyListItemLabel;
PropertyList.ItemValue = PropertyListItemValue;

export default PropertyList;
